module.exports = __webpack_public_path__ + "img/business-and-finance-3.4e2ae174.svg";